import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'unescapehtml',
    standalone: true
})
export class UnescapePipe implements PipeTransform {

    transform(value: string, args?: unknown): string {

        const domParser = new DOMParser();
        const doc = domParser.parseFromString(`<div id="parent">${value}</div>`, 'text/html');

        // Implementing embedded videos by interpreting the block-quotes of the Dx html editor as raw html.
        doc.querySelectorAll('pre').forEach(quoteElement => {
            // We should always have at least the <div parent> as parent.
            const parent = quoteElement.parentElement;

            const newHtml = this.htmlToElement(quoteElement.textContent);

            newHtml.childNodes.forEach(node => {
                parent.insertBefore(node, quoteElement);
            });
            parent.removeChild(quoteElement);
        });

        return doc.querySelector('div#parent').innerHTML;
    }

    private htmlToElement(html: string): DocumentFragment {
        return this.htmlToTemplateContent(html).content;
    }

    private htmlToTemplateContent(html: string): HTMLTemplateElement {
        var template = document.createElement('template');
        html = html.trim(); // Never return a text node of whitespace as the result
        template.innerHTML = html.replace(/\u00a0/g, " ");;
        return template;
    }
}
